setVideoProcessing